import { IPv4, IPv6, IPv4CidrRange, IPv6CidrRange } from 'ip-num';

export function isValidIPAddress(address: string): boolean {
  return isValidIPv4(address) || isValidIPv6(address);
}

export function isIpInRange(ipAddress: string, cidrRange: string): boolean {
  if (isValidIPv4(ipAddress) && isValidIPv4Range(cidrRange)) {
    return IPv4CidrRange.fromCidr(cidrRange).contains(new IPv4(ipAddress));
  } else if (isValidIPv6(ipAddress) && isValidIPv6Range(cidrRange)) {
    return IPv6CidrRange.fromCidr(cidrRange).contains(new IPv6(ipAddress));
  }
  return false;
}

export function isValidIPv4(address: string): boolean {
  try {
    new IPv4(address);
    return true;
  } catch (e) {
    return false;
  }
}

export function isValidIPv6(address: string): boolean {
  try {
    new IPv6(address);
    return true;
  } catch (e) {
    return false;
  }
}

export function isValidIPv4Range(cidrRange: string): boolean {
  try {
    IPv4CidrRange.fromCidr(cidrRange);
    return true;
  } catch (e) {
    return false;
  }
}

export function isValidIPv6Range(cidrRange: string): boolean {
  try {
    IPv6CidrRange.fromCidr(cidrRange);
    return true;
  } catch (e) {
    return false;
  }
}

export function normalizeIPAddress(address: string): string {
  if (address.indexOf('::ffff:') === 0) {
    return address.replace('::ffff:', '');
  } else {
    return address;
  }
}
